import { Injectable, OnDestroy, Inject } from '@angular/core';

import { combineLatest, filter, Subscription } from 'rxjs';

import { AbstractHypeService } from '../../../Common/Layout/services/abstract-hype.service';
import { ReportsLeftSidebarService } from './reports-left-sidebar.service';
import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { ReportsRoutingService } from './reports-routing.service';


@Injectable()
export class ReportsHypeService extends AbstractHypeService implements OnDestroy {
    private subscriptions: Subscription[] = [];

    constructor(
        private reportRoutingService: ReportsRoutingService,
        private sidebarService: ReportsLeftSidebarService,
        private currentUserStateService: CurrentUserStateService
    ) {
        super();

        this.subscriptions.push(
            combineLatest([
                this.reportRoutingService.getCurrentRoute$().pipe(
                    filter(route => !!route)
                ),
                this.currentUserStateService.getAccount().pipe(
                    filter(account => !!account)
                ),
            ]).subscribe(([route, account]) => {
                this.initializeReportsHype();
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach((value) => {
            value.unsubscribe();
        });
    }

    private initializeReportsHype(): void {
        this.hypeConfig = {
            icon: 'fa-kit-duotone fa-agpr-hype-reports',
            headingText: 'Monitor.hype.reports.headline',
            line1Text: 'Monitor.hype.reports.line1',
            line2Text: 'Monitor.hype.reports.line2',
            linkText: 'Monitor.hype.reports.link'
        };
        this.hypeConfigProvider.next(this.hypeConfig);
    }

    buttonClicked(): void {
        this.sidebarService.showReportAmplifyDialog();
    }

    secondaryButtonClicked(): void {}
}
